let extractIdCounter = 1;

// Pure function: advance the active processing job by 1 day
export function processProcessingDay(state) {
  const procRoom = state.rooms.find(r => r.type === 'processing' && r.unlocked);
  if (!procRoom || !procRoom.processingQueue?.length) return state;

  const activeJob = procRoom.processingQueue.find(j => j.status === 'active');
  if (!activeJob) return state;

  const newDays = activeJob.daysAccumulated + 1;

  // Not yet complete — just increment counter
  if (newDays < activeJob.daysRequired) {
    const updatedQueue = procRoom.processingQueue.map(j =>
      j.inventoryId === activeJob.inventoryId
        ? { ...j, daysAccumulated: newDays }
        : j
    );
    return {
      ...state,
      rooms: state.rooms.map(r =>
        r.id === procRoom.id ? { ...r, processingQueue: updatedQueue } : r
      ),
    };
  }

  // Job complete — produce output
  let newInventory = [...state.inventory];
  let outputMessage = '';

  if (activeJob.mode === 'packaging') {
    // Return item to inventory with packaged:true, restore original status
    newInventory = newInventory.map(i =>
      i.id === activeJob.inventoryId
        ? { ...i, packaged: true, packageTier: 1, status: activeJob.originalStatus ?? 'fresh' }
        : i
    );
    outputMessage = `📦 Processing complete: ${activeJob.inputGrams}g packaged`;

  } else if (activeJob.mode === 'extract') {
    // Yield formula: quality + worker skill dependent
    const yieldFactor = 0.12 + ((activeJob.qualitySnapshot ?? 60) / 100) * 0.12;
    const skillBonus  = ((activeJob.workerSkillSnapshot ?? 50) / 100) * 0.04;
    const outputGrams = Math.max(1, Math.round(activeJob.inputGrams * (yieldFactor + skillBonus)));

    const extractTHC = Math.min((activeJob.thcSnapshot ?? 14) * 2.5, 40);

    const extractItem = {
      id: `inv-e-${state.gameDay}-${extractIdCounter++}`,
      type: 'extract',
      extractType: activeJob.extractType,
      grams: outputGrams,
      qualityScore:     activeJob.qualitySnapshot  ?? 60,
      thcAccumulation:  extractTHC,
      terpeneProfile:   activeJob.terpeneSnapshot  ?? 50,
      visualAppeal:     activeJob.visualAppealSnapshot ?? activeJob.terpeneSnapshot ?? 50,
      strainId:         activeJob.strainIdSnapshot ?? 'unknown',
      harvestDay:       activeJob.harvestDaySnapshot ?? 1,
      status: 'fresh',
    };

    // Remove input item (consumed), add extract item
    newInventory = newInventory.filter(i => i.id !== activeJob.inventoryId);
    newInventory = [...newInventory, extractItem];
    outputMessage = `💎 Extract complete: ${outputGrams}g ${activeJob.extractType}`;
  } else {
    // Unknown mode — skip to avoid corrupt state
    return state;
  }

  // Remove completed job; promote first pending to active
  const remaining = procRoom.processingQueue.filter(j => j.inventoryId !== activeJob.inventoryId);
  const promoted  = remaining.map((j, idx) =>
    idx === 0 && j.status === 'pending' ? { ...j, status: 'active' } : j
  );

  return {
    ...state,
    rooms: state.rooms.map(r =>
      r.id === procRoom.id ? { ...r, processingQueue: promoted } : r
    ),
    inventory: newInventory,
    notifications: [
      ...state.notifications,
      { id: `notif-proc-done-${state.gameDay}-${activeJob.inventoryId}`, message: outputMessage, type: 'success', day: state.gameDay, read: false },
    ].slice(-50),
  };
}
